import { render, staticRenderFns } from "./HoverPage.vue?vue&type=template&id=2e904f8c&scoped=true&"
import script from "./HoverPage.vue?vue&type=script&lang=js&"
export * from "./HoverPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e904f8c",
  null
  
)

export default component.exports